<template>
  <v-app id="scanradio">
    <v-navigation-drawer v-model="navigationVisible" :width="navigationWidth"  app>
      <v-list nav dense>
        <v-list-item-group max="1">
          <v-list-item to="/" link>
            <v-list-item-content @click="linkClick('/')">
             <v-list-item-title>
               <v-icon medium>home</v-icon>
             </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            v-for="item in channelList"
            :key="item.channel"
            :to="item.link + remainderOfLink"
            link
          >
            <v-list-item-content @click="linkClick(item.link + remainderOfLink)">
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app dense color="indigo" dark>
      <v-app-bar-nav-icon @click="navigationVisible = !navigationVisible"></v-app-bar-nav-icon>
      <v-toolbar-title>ScanRad.io</v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-slot:extension v-if="$route.name !== 'home'">
          <v-tabs v-model="activeTab" align-with-title>
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab key="decode" :to="decodeRoute">
              Decode
            </v-tab>
            <v-tab key="activity" :to="activityRoute">
              Activity
            </v-tab>
            <v-tabs-items v-model="activeTab" @change="updateRouter($event)">
              <v-tab-item key="decode" :to="decodeRoute">
              </v-tab-item>
              <v-tab-item key="activity" :to="activityRoute">
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <v-spacer></v-spacer>
          <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  max-height="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      label="Select Date"
                      prepend-icon="event"
                      readonly
                      outlined
                      dense
                      :value="dateValue"
                      v-on="on"
              >
              </v-text-field>
            </template>

            <v-date-picker v-model="dateValue" no-title @input="updateDate()">
            </v-date-picker>
          </v-menu>
          <v-btn icon @click="dateValue=''; updateDate()"><v-icon>clear</v-icon></v-btn>
          <v-spacer></v-spacer>
      </template>
      <v-spacer></v-spacer>



      <template>
        <v-menu
                eager
                offset-y
                v-model="userMenu"
                :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small v-if="!authenticated" color="red" @click="login"><v-icon>person</v-icon>Login</v-btn>
            <v-btn x-small v-else color="green" v-bind="attrs" v-on="on"><v-icon x-small>person</v-icon>{{ user.data.email }}</v-btn>
          </template>

          <v-card v-if="!authenticated">
            <v-card-subtitle class="subtitle-2 lighten-2">
              Login to ScanRad.io
            </v-card-subtitle>
            <v-row>
            <div id='firebaseui-auth-container'></div>
            </v-row>
            <v-row>
            <v-spacer></v-spacer>
          </v-row>
          </v-card>

          <v-card v-else>
            <v-card-subtitle class="subtitle-2 lighten-2">Signed in as:</v-card-subtitle>
            <v-card-text class="body-2">{{ user.data.email }}</v-card-text>
            <v-card-text class="body-2 green--text" v-if="isPremium">Premium Access</v-card-text>
            <v-card-actions>
              <v-btn text color="green accent-4" @click="manageSubscription" v-if="isPremium">Manage Premium Access</v-btn>
              <v-btn text color="green accent-4" @click="subscribe" v-else>Add Premium Access</v-btn>
              <v-btn
                      text
                      color="red accent-4"
                      @click="logout"
              >
                Sign out
              </v-btn>
              </v-card-actions>
          </v-card>
        </v-menu>
      </template>


    </v-app-bar>

    <v-main>

      <v-dialog hide-overlay v-click-outside=false model="linkCopiedDialog">
        <v-card>
          <v-card-text>
            Link copied to clipboard
          </v-card-text>
        </v-card>
      </v-dialog>
      <audio id="audioPlayer" v-on:timeupdate="audioTimeUpdateEvent" v-on:loadedmetadata="audioLoadedMetadataEvent"  v-on:play="audioPlayEvent" v-on:pause="audioPauseEvent" v-on:ended="audioEndedEvent"></audio>

      <v-container fluid>
        <router-view @playback="onPlayback"></router-view>
      </v-container>
    </v-main>

    <template v-if="isMobile">
      <div tabindex="-1" class="v-dialog__content v-dialog__content--active" style="z-index: 202; height:auto; bottom:0;" v-show="playbackBarDisplayed">
        <div class="v-dialog v-bottom-sheet v-dialog--active v-dialog--persistent">

          <v-sheet tile class="ma-0">

            <v-row align="center" class="ma-0">
              {{nowPlayingMode}}

              <v-spacer></v-spacer>

              <v-btn small fab class="ma-1" color="green" @click="onPlayButton"><v-icon dark>mdi-play</v-icon></v-btn>

              <v-speed-dial
                  v-model="fabShare"
                  direction="top"
                  transition="slide-y-reverse-transition">
                <template v-slot:activator>
                  <v-btn small fab class="ma-1"
                         v-model="fabShare"
                         color="blue"
                  >
                    <v-icon v-if="fabShare">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-share
                    </v-icon>
                  </v-btn>
                </template>

                <ShareNetwork
                    network="facebook"
                    :url=shareUrl()
                    :title=shareTitle()
                    hashtags="scanradio"
                >
                  <v-btn fab  color="white"><v-icon dark >mdi-facebook</v-icon></v-btn>
                </ShareNetwork>

                <ShareNetwork
                    network="twitter"
                    :url=shareUrl()
                    :title=shareTitle()
                    hashtags="scanradio"
                >
                  <v-btn fab  color="white"><v-icon dark >mdi-twitter</v-icon></v-btn>
                </ShareNetwork>

                <v-btn fab color="white" @click="onCopyLink"><v-icon dark >mdi-link-variant</v-icon></v-btn>


              </v-speed-dial>


             <v-btn small fab class="ma-1" color="red" @click="onAudioCloseButton"><v-icon >mdi-stop-circle</v-icon></v-btn>

              <!-- <v-btn class="ma-1" color="blue"  fab @click="onSkipNextButton"><v-icon large dark>mdi-skip-next</v-icon></v-btn> -->
              <!-- <v-btn class="ma-1" color="teal"  fab><v-icon large dark>mdi-share</v-icon></v-btn> -->
            </v-row>
          </v-sheet>
        </div></div>

    </template>
    <template v-else>
    <div tabindex="-1" class="v-dialog__content v-dialog__content--active" style="z-index: 202; height:auto; bottom:0;" v-show="playbackBarDisplayed">
    <div class="v-dialog v-bottom-sheet v-bottom-sheet--inset v-dialog--active v-dialog--persistent">

      <v-sheet tile class="ma-0">
        <v-row class="ma-0"><v-progress-linear class="my-0" height="3" id="playProgress"></v-progress-linear></v-row>
        <v-row><v-spacer></v-spacer><v-icon right class="mt-n6 mr-n1" small @click="onAudioCloseButton">mdi-close-circle</v-icon></v-row>

        <v-row align="center" class="ma-0">

          <v-list dense>
            <v-list-item>Now Playing: {{nowPlayingChannel}} from {{nowPlayingTime}}</v-list-item>
            <v-list-item>Playback Time: {{nowPlayingRealTime}} | Mode: {{nowPlayingMode}}</v-list-item>
          </v-list>

          <v-spacer></v-spacer>

       <v-btn class="ma-1" color="blue" fab @click="onSkipBackButton"><v-icon large dark>mdi-skip-previous</v-icon></v-btn>
       <v-btn class="ma-1" color="blue" x-large fab @click="onPlayButton"><v-icon x-large dark>mdi-play</v-icon></v-btn>
       <v-btn class="ma-1" color="blue"  fab @click="onPauseButton"><v-icon large dark>mdi-pause</v-icon></v-btn>
      <!-- <v-btn class="ma-1" color="blue"  fab @click="onSkipNextButton"><v-icon large dark>mdi-skip-next</v-icon></v-btn> -->

          <v-speed-dial
              v-model="fabDownload"
              direction="top"
              transition="slide-y-reverse-transition">
            <template v-slot:activator>
              <v-btn class="ma-1"
                  v-model="fabDownload"
                  color="indigo"
                  fab
              >
                <v-icon v-if="fabDownload">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-download
                </v-icon>
              </v-btn>
            </template>


            <v-btn fab  color="maroon" @click="doDownload(5*60)">5 min</v-btn>
            <v-btn fab  color="maroon" @click="doDownload(30*60)">30 min</v-btn>
            <v-btn fab  color="maroon" @click="doDownload(1*60*60)">1 hr</v-btn>
            <v-btn fab  color="maroon" @click="doDownload(4*60*60)">4 hr</v-btn>

          </v-speed-dial>

      <!-- <v-btn class="ma-1" color="teal"  fab><v-icon large dark>mdi-share</v-icon></v-btn> -->

          <v-speed-dial
              v-model="fabShare"
              direction="top"
              transition="slide-y-reverse-transition">
            <template v-slot:activator>
              <v-btn class="ma-1"
                     v-model="fabShare"
                     color="teal"
                     fab
              >
                <v-icon v-if="fabShare">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-share
                </v-icon>
              </v-btn>
            </template>

            <ShareNetwork
                network="facebook"
                :url=shareUrl()
                :title=shareTitle()
                hashtags="scanradio"
            >
              <v-btn fab  color="white"><v-icon dark large>mdi-facebook</v-icon></v-btn>
            </ShareNetwork>

            <ShareNetwork
                network="twitter"
                :url=shareUrl()
                :title=shareTitle()
                hashtags="scanradio"
            >
              <v-btn fab  color="white"><v-icon dark large>mdi-twitter</v-icon></v-btn>
            </ShareNetwork>

            <v-btn fab color="white" @click="onCopyLink"><v-icon dark large>mdi-link-variant</v-icon></v-btn>


          </v-speed-dial>


        </v-row>
      </v-sheet>
      </div></div>

    </template>

  </v-app>
</template>



<script>
import moment from "moment";
import EventBus from './event-bus';
import firebase from "./firebase";
import * as firebaseui from "firebaseui";

export default {
  props: {
    source: String
  },
  mounted: function() {

    firebase.auth.onAuthStateChanged( user => {
      if (user) {
        console.log("user logged in true")
        this.user.loggedIn = true;
        this.user.data = user;
        firebase.getCustomClaimRole()
                .then((result) => {
                          console.log("claim result " + result)
                          if (result == 'premium') {
                            console.log("setting premium true");
                            this.isPremium = true;
                          }
                          else
                          {
                            console.log("setting premium false in promise")
                            this.isPremium = false;
                          }
                        }
                )
                .catch(error => {console.log("premium error "+error); this.isPremium = false})


      }
      else {
        console.log("user logged in false")
        this.user.loggedIn = false;
        this.user.data = {};
        console.log('premium false due to logged out')
        this.isPremium = false
      }

      this.userMenu = false;  // always hide when state changes
    })

    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth);
    }

    if (ui.isPendingRedirect()) {
      console.log("isPendingRedirect true")
      this.userMenu = true
      ui.start('#firebaseui-auth-container', firebase.uiConfig);
    }


    if(this.$route.query.date)
      {
        var requestDate = moment(this.$route.query.date, 'YYYY-MM-DD', true);
        if(requestDate.isValid()) {
          this.dateValue = requestDate.format('YYYY-MM-DD')
          this.$store.dispatch('setDateAction', this.dateValue)
        }
        else
          this.$router.push({ path: this.$router.currentRoute.path })
      }



    this.$axios
      .get("/channellist")
      .then(response => {
        this.channelList = response.data;
        this.channelList.forEach(item => {
          item.link = "/c/" + item.channel;
        });

        // waits for channel list to load because we need it...
        if(this.$route.query.playfrom)
        {
          var fromValue = this.$route.query.playfrom;
          this.onPlayback(this.$route.params.channel, fromValue);
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  methods: {
    login() {
      //this.loginDialog = true
      this.userMenu = true
      console.log("login click")
      firebase.login()
      console.log("had called firebase login")
    },
    logout() {
      firebase.logout()
    },
    updateRouter(val) {
      this.$router.push(val)
    },
    updateDate() {
      this.$store.dispatch('setDateAction', this.dateValue)
      if(this.dateValue.length == 10)
        this.$router.push({ path: this.$router.currentRoute.path, query: { date: this.dateValue }})
      else
        this.$router.push({path: this.$router.currentRoute.path})
      this.dateMenu = false
    },
    dateQuery() {
      var dateQuery = ''
      if(this.dateValue.length == 10)
        dateQuery = '?date='+this.dateValue
      return dateQuery
    },
    linkClick(newPath) {
      if(newPath == this.$router.currentRoute.path && this.$router.currentRoute.name != 'home')
      {
        EventBus.$emit('reload');
      }
      if(this.$vuetify.breakpoint.mdAndDown)
        this.navigationVisible = false;
    },
    shareUrl() {
      if(this.activeTab.includes('activity'))
        return 'https://scanrad.io/c/' + this.playingChannelId + '/activity?playfrom=' + this.playingTimestamp;
      else
        return 'https://scanrad.io/c/' + this.playingChannelId + '/decode?playfrom=' + this.playingTimestamp;
    },
    shareTitle() {
      return this.nowPlayingChannel+" on ScanRad.io";
    },
    onCopyLink() {
      navigator.clipboard.writeText(this.shareUrl()).then(() => {
        this.linkCopiedDialog = true;
        setTimeout(() => { this.linkCopiedDialog = false}, 2000);
      }, function() {
        /* clipboard write failed */
      });

    },
    onAudioCloseButton()
    {
      this.abortInterval()
      var x = document.getElementById("audioPlayer");
      x.pause();
      this.isAudioPlaying = false;
      this.playbackBarDisplayed = false;
    },



    onSkipBackButton() {
      this.startPlayback();
    },
    onPlayButton() {
      if(this.interPaused == true)
      {
        this.interPaused = false;
      }
      else {
        if(this.canInterPause)
        {
          // do nothing
        } else
        {
        var x = document.getElementById("audioPlayer");
          var playPromise = x.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              console.log("play start")
            }).catch(error => {
              console.log("play error caught " + error + " ");
              this.nowPlayingMode = "Play Error";
            });
          }        }
      }
    },
    onPauseButton() {
      if(this.canPauseMedia)
      {
        var x = document.getElementById("audioPlayer");
        x.pause();
      }
      else
      {
        if(this.canInterPause)
          this.interPaused = true;
        // else nop
      }
    },
    onSkipNextButton() {
      // TODO
    },
    abortInterval() {
      if(this.liveInterval !== null)
      {
        console.log("doing abort interval");
        clearInterval(this.liveInterval);
        this.liveInterval = null;
      }
    },
    startPlayback() {
      this.abortInterval();
      var x = document.getElementById("audioPlayer");
      x.setAttribute(
          "src",
          "/playback/" + this.playingChannelId + "/" + this.playingTimestamp
      );
      this.canPauseMedia = false;
      this.interPaused = false;
      this.nowPlayingMode = "Load";
      x.load();
      var playPromise = x.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          console.log("play start")
        }).catch(error => {
          console.log("play error caught " + error + " ");
          this.nowPlayingMode = "Press Play to Start...";
        });
      }
    },
    onPlayback(channel, time) {
      this.playingChannelId = channel;
      this.playingTimestamp = time;
      this.playbackBarDisplayed = true;
      this.nowPlayingChannel = this.channelList.find(x => x.channel == channel).name;
      this.nowPlayingTime = moment.unix(this.playingTimestamp).format('ddd M/D/YYYY HH:mm:ss');
      this.startPlayback();
    },
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'scanradio.mp3') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    doDownload(duration) {
      this.$axios({
        method: 'get',
        url: "/download/" + this.playingChannelId + "/" + this.playingTimestamp + "?t=" + duration,
        responseType: 'arraybuffer'
      }).then(response => { this.forceFileDownload(response)
      }).catch(() => console.log('download error'))
    },
    audioLoadedMetadataEvent() {
      var initialTS = this.$cookies.get("initialTS");
      var timeData = this.$cookies.get("timeData");

      var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
      var charToDec = {};
      var i;

      // TODO: precompute the conversion array rather than doing every time
      for (i = 0; i < alphabet.length; i++) {
        var char = alphabet[i];
        charToDec[char] = i;
      }
      if(initialTS == 0)
        initialTS = this.$cookies.get("continueTS");
      this.timeArray = [ {f: 0, t: Number(initialTS)}];

      if(timeData === null)
      {
        //nop
      }
      else {
        for (i = 0; i < timeData.length; i += 5) {
          var frameVal = charToDec[timeData.charAt(0 + i)] << 12;
          frameVal |= charToDec[timeData.charAt(1 + i)] << 6;
          frameVal |= charToDec[timeData.charAt(2 + i)];
          var timeVal = charToDec[timeData.charAt(3 + i)] << 6;
          timeVal |= charToDec[timeData.charAt(4 + i)];
          timeVal += Number(initialTS);
          this.timeArray.push({f: frameVal, t: timeVal});
        }
      }


      this.nowPlayingRealTime = moment.unix(Number(initialTS)).format('M/D/YY HH:mm:ss');

      this.$cookies.remove("initialTS");  // keep from sending back
      this.$cookies.remove("timeData");   // keep from sending back
    },
    audioTimeUpdateEvent() {

      var x = document.getElementById("audioPlayer"); // TODO get this once on doc load
      var time = x.currentTime;
      if(time == 0)
        return; // we'll update a different way, since this comes too early
      var frames = time/0.072;  // 16 kHz frame rate (should come from server, but...)

      var tlast = Number(this.timeArray[0].t);

      // TODO: binary search here? or just remember last time we were called and start from there, not zero?

      for(var i = 0; i<this.timeArray.length; i++)
      {
        var te = this.timeArray[i];
        if(Number(te.f) > frames)
          break;
        tlast = Number(te.t);
      }
      this.nowPlayingRealTime = moment.unix(tlast).format('M/D/YY HH:mm:ss'); // TODO: store as times, convert format in display
    },
    audioPlayEvent() {
      this.nowPlayingMode = "Play"
      this.isAudioPlaying = true;
      this.canPauseMedia = true;
      this.canInterPause = false;
    },
    audioPauseEvent() {
      this.nowPlayingMode = "Pause"
      this.canPauseMedia = false;
      // fires too often to clear isAudioPlaying.
    },
    audioEndedEvent() {
      console.log("ended-evt");
      this.abortInterval();
      if(this.$cookies.get("continueLive") == "true")
      {
        this.nowPlayingMode = "Live Wait";
        this.canInterPause = true;
        var nth = 0;
        var everynth = 1;
        this.liveInterval = setInterval(() => {
          this.canInterPause = true;
          if(this.interPaused)
          {
            this.nowPlayingMode = "Live Paused";
            everynth = 1;
          }
          else {
            ++nth;
            if (nth > everynth) {
              nth = 0;
              this.nowPlayingMode = "Live Checking...";
              this.$axios
                  .get("/latest/" + this.$cookies.get("continueChannel"))
                  .then(response => {
                    var latestTime = response.data;
                    console.log("latest " + latestTime + " continueTS " + this.$cookies.get("continueTS"));
                    if (this.liveInterval === null) {
                      console.log("liveInterval became null while checking"); // unlikely
                    } else {
                      if (latestTime > this.$cookies.get("continueTS")) {
                        this.abortInterval();
                        var x = document.getElementById("audioPlayer");
                        x.setAttribute(
                            "src",
                            "/playback/" + this.$cookies.get("continueChannel") + "/" + this.$cookies.get("continueTS") + "?cts=" + latestTime
                        );
                        this.nowPlayingMode = "Live Loading";
                        x.load();
                        this.canPauseMedia = false;
                        console.log("playing live from " + this.$cookies.get("continueTS"));
                        x.play();
                      } else {
                        this.nowPlayingMode = "Live Waiting";
                        everynth *= 3;
                        if (everynth > 24)
                          everynth = 24;
                      }
                    }
                  })
                  .catch(err => {
                    console.error(err);
                  });
            }
          }
        }, 229)
      } else {
        this.nowPlayingMode = "Wait"
        setTimeout(() => {
          var x = document.getElementById("audioPlayer");
          x.setAttribute(
              "src",
              "/playback/" + this.$cookies.get("continueChannel") + "/" + this.$cookies.get("continueTS")
          );
          this.nowPlayingMode = "Load";
          this.canPauseMedia = false;
          x.load();
          console.log("playing from " + this.$cookies.get("continueTS"));
          var playPromise = x.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              console.log("playing")
            }).catch(error => {
              console.log("play error caught " + error + " ");
              this.nowPlayingMode = "Play Error";
            })
          }
        }, 250);
      }
    },
    async subscribe() {
      this.userMenu = false
      const docRef = await firebase.db
              .collection('customers')
              .doc(this.user.data.uid)
              .collection('checkout_sessions')
              .add({
                price: 'price_1HCDQvHvwu7t8P6sGIoLEZQ1',
                success_url: window.location.origin,
                cancel_url: window.location.origin,
              });
// Wait for the CheckoutSession to get attached by the extension
      docRef.onSnapshot((snap) => {
        const { sessionId } = snap.data();
        if (sessionId) {
          // We have a session, let's redirect to Checkout
          // Init Stripe
          /* global Stripe */
          const stripe = Stripe('pk_live_51HBuJ8Hvwu7t8P6scojqMdsdvpNHRa88zxsQIKuY9HYen7KbzatYRu6y3kFhERC58pV9S5YHXZs1ItG5naZWsXIr00yt6FM3eG');
          stripe.redirectToCheckout({ sessionId });
        }
      });
    },
    async manageSubscription() {
      this.userMenu = false
      const functionRef = firebase
              .app()
              .functions('${param:LOCATION}')
              .httpsCallable('${function:createPortalLink.name}');
      const { data } = await functionRef({ returnUrl: window.location.origin });
      window.location.assign(data.url);
    }
  },
  computed: {

    remainderOfLink() {
      if(this.activeTab.includes('activity'))
        return '/activity'+this.dateQuery();
      else
        return '/decode'+this.dateQuery();
    },
    decodeRoute() {
        return '/c/' + this.$route.params.channel + '/decode'+this.dateQuery()
    },
    activityRoute() {
        return '/c/' + this.$route.params.channel + '/activity'+this.dateQuery()
    },
    navigationWidth() {
      if(this.$vuetify.breakpoint.xsOnly)
        return '100%'
      else
        return '256'
    },
    isMobile()
    {
      return (this.$vuetify.breakpoint.xsOnly)
    },
    authenticated(){
      return this.user.loggedIn
    },
  },
  data: () => ({
    timeArray: null,
    linkCopiedDialog: false,
    fabShare: false,
    fabDownload: false,
    canInterPause: false,
    canPauseMedia: false,
    interPaused: false,
    nowPlayingMode: "Unknown",
    nowPlayingChannel: "",
    nowPlayingTime: "",
    nowPlayingRealTime: "",
    playingChannelId: null,
    playingTimestamp: null,
    playbackBarDisplayed: false,
    isAudioPlaying: false,
    liveInterval: null,
    navigationVisible: null,
    channelList: null,
    dateValue: '',
    activeTab: '',
    dateMenu: false,
    userMenu: false,
    user: {
      loggedIn: false,
      data: {}
    },
    isPremium: false,
  })
};
</script>


